import { useLazyGetRechargeBankSlipQuery } from '../services/benefitApi';
export function useRechargeBankSlip() {
    const [trigger, result] = useLazyGetRechargeBankSlipQuery();
    const fetchBankSlip = (params) => {
        trigger(params);
    };
    return {
        bankSlip: result.data || null,
        isLoading: result.isLoading,
        isError: result.isError,
        isSuccess: result.isSuccess,
        fetchBankSlip,
    };
}
